import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";
import defaultAvatar from "../../../../assets/images/avatar.png";
import { useDispatch } from "react-redux";
import { updateHrmsUser } from "../../../../Redux/slice/features/authSlice";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { employeeApi } from "../../../../api/employeeApi";

const EmployeeViewEditModal = ({
    show,
    onClose,
    employee,
    editMode,
    setEditMode,
    onSuccess,
}) => {
    const [formData, setFormData] = useState({});
    const [imageFile, setImageFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [passwordForm, setPasswordForm] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const [resetLoading, setResetLoading] = useState(false);
    const dispatch = useDispatch();
    const userType = useSelector((state) => state.auth.userType);
    const appendIfValid = (fd, key, value) => {
        if (
            value !== undefined &&
            value !== null &&
            value !== "" &&
            value !== "null"
        ) {
            fd.append(key, value);
        }
    };

    useEffect(() => {
        setFormData(employee || {});
        setPasswordForm({
            newPassword: "",
            confirmPassword: "",
        });
    }, [employee]);

    const showToast = (icon, title) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon,
            title,
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
        });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImageFile(file);
        setPreview(URL.createObjectURL(file));
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();

        if (!String(passwordForm.newPassword || "").trim()) {
            showToast("error", "New Password is required");
            return;
        }

        if (!String(passwordForm.confirmPassword || "").trim()) {
            showToast("error", "Confirm Password is required");
            return;
        }

        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            showToast("error", "Confirm Password must match New Password");
            return;
        }

        try {
            setResetLoading(true);
            const res = await employeeApi.resetEmployeePassword(employee.Id, {
                newPassword: passwordForm.newPassword,
                confirmPassword: passwordForm.confirmPassword,
            });

            showToast("success", res?.message || "Password reset successfully");
            setPasswordForm({
                newPassword: "",
                confirmPassword: "",
            });
        } catch (err) {
            const message =
                typeof err === "string"
                    ? err
                    : err?.message ||
                    err?.response?.data?.message ||
                    "Failed to reset password. Please try again.";
            showToast("error", message);
        } finally {
            setResetLoading(false);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        const formDataPayload = new FormData();
        const normalizeDate = (date) =>
            date ? new Date(date).toISOString() : null;

        appendIfValid(formDataPayload, "Name", formData.vchFullName);
        appendIfValid(formDataPayload, "Email", formData.vchEmail);
        appendIfValid(formDataPayload, "Mobile", formData.vchMobTel);
        appendIfValid(formDataPayload, "Address", formData.vchPreAddress);
        appendIfValid(formDataPayload, "Department", formData.vchDepartment);
        appendIfValid(formDataPayload, "Designation", formData.vchDesignation);
        appendIfValid(formDataPayload, "CompanyName", formData.vchCompanyName);
        appendIfValid(formDataPayload, "Gender", formData.vchGender);

        if (formData.dtmDob) {
            formDataPayload.append("Dob", normalizeDate(formData.dtmDob));
        }
        if (formData.dtmDoj) {
            formDataPayload.append("DateOfJoining", normalizeDate(formData.dtmDoj));
        }

        if (imageFile) {
            formDataPayload.append("UserImage", imageFile);
        }

        try {
            const res = await axios.put(
                `${REACT_APP_API_URL}api/hrms/update-employee/${employee.Id}`,
                formDataPayload,
                {
                    withCredentials: true,
                }
            );

            window.alert(res.data.message || "Employee updated successfully");

            const updatedHrmsUser = {
                name: formData.vchFullName,
                employee_id: employee.vchEmpCode,
                department: formData.vchDepartment,
                designation: formData.vchDesignation,
                vchUserImage: res.data.userImage || employee.vchUserImage
            };

            dispatch(updateHrmsUser(updatedHrmsUser));
            if (onSuccess) onSuccess(updatedHrmsUser);

            setPreview(null);
            setImageFile(null);
            onClose();

        } catch (err) {
            console.error("Update failed:", err);
            window.alert("Failed to update employee. Please try again.");
        }
    };

    if (!employee) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content border-0 rounded-4 shadow-lg">

                    {/* Header */}
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {editMode ? "Update Employee" : "Employee Details"}
                        </h5>

                        {!editMode && (
                            <button
                                className="btn btn-sm btn-outline-warning m-3 me-2"
                                onClick={() => setEditMode(true)}
                            >
                                Edit
                            </button>
                        )}

                        <button className="btn-close" onClick={onClose} />
                    </div>

                    {/* Body */}
                    <div className="modal-body pt-3">
                        <div className="row g-4">
                            <div className="col-lg-4 text-center">
                                <div className="card border-0 bg-body-tertiary rounded-4 h-100">
                                    <div className="card-body p-4">
                                        <img
                                            src={
                                                preview ||
                                                (employee?.vchUserImage
                                                    ? `${REACT_APP_API_URL}${employee.vchUserImage.replace(/\\/g, "/")}?t=${Date.now()}`
                                                    : defaultAvatar)
                                            }
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultAvatar;
                                            }}
                                            className="rounded-circle mb-3 border shadow-sm"
                                            width="132"
                                            height="132"
                                            alt="Employee"
                                        />

                                        <h5 className="mb-1">{employee.vchFullName}</h5>
                                        <div className="text-muted small mb-3">{employee.vchEmpCode}</div>
                                        <div className="d-grid gap-2">
                                            {editMode && (
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                {!editMode ? (
                                    <div className="card border-0 shadow-sm rounded-4 h-100">
                                        <div className="card-body p-4">
                                            <div className="d-flex flex-wrap gap-2 mb-3">
                                                <span className="badge bg-primary-subtle text-primary-emphasis border border-primary-subtle">
                                                    {employee.vchEmpCode}
                                                </span>
                                                <span className="badge bg-light text-dark border">
                                                    {employee.vchDesignation || "No designation"}
                                                </span>
                                                <span className="badge bg-light text-dark border">
                                                    {employee.vchDepartment || "No department"}
                                                </span>
                                            </div>

                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Email</small>
                                                        <div className="fw-semibold text-break">{employee.vchEmail || "-"}</div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Phone</small>
                                                        <div className="fw-semibold">{employee.vchMobTel || "-"}</div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Address</small>
                                                        <div className="fw-semibold">{employee.vchPreAddress || "-"}</div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Company</small>
                                                        <div className="fw-semibold">{employee.vchCompanyName || "-"}</div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Date of Joining</small>
                                                        <div className="fw-semibold">
                                                            {employee.dtmDoj ? employee.dtmDoj.split("T")[0] : "-"}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Date of Birth</small>
                                                        <div className="fw-semibold">
                                                            {employee.dtmDob ? employee.dtmDob.split("T")[0] : "-"}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="bg-body-tertiary rounded-3 p-3 h-100">
                                                        <small className="text-muted d-block mb-1">Gender</small>
                                                        <div className="fw-semibold">{employee.vchGender || "-"}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {userType === "admin" && (
                                                <div className="card border-0 bg-light rounded-4 mt-4">
                                                    <div className="card-body p-3 p-xl-4">
                                                        <h6 className="fw-semibold mb-3">Reset Password</h6>
                                                        <form onSubmit={handlePasswordReset}>
                                                            <div className="row g-3">
                                                                <div className="col-md-6">
                                                                    <label className="form-label">New Password</label>
                                                                    <input
                                                                        type="password"
                                                                        className="form-control"
                                                                        value={passwordForm.newPassword}
                                                                        onChange={(e) =>
                                                                            setPasswordForm((prev) => ({
                                                                                ...prev,
                                                                                newPassword: e.target.value,
                                                                            }))
                                                                        }
                                                                        placeholder="Enter new password"
                                                                    />
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <label className="form-label">Confirm Password</label>
                                                                    <input
                                                                        type="password"
                                                                        className="form-control"
                                                                        value={passwordForm.confirmPassword}
                                                                        onChange={(e) =>
                                                                            setPasswordForm((prev) => ({
                                                                                ...prev,
                                                                                confirmPassword: e.target.value,
                                                                            }))
                                                                        }
                                                                        placeholder="Re-enter new password"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="text-end mt-3">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-warning"
                                                                    disabled={resetLoading}
                                                                >
                                                                    {resetLoading ? "Resetting..." : "Reset Password"}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card border-0 shadow-sm rounded-4 h-100">
                                        <div className="card-body p-4">
                                            <form onSubmit={handleUpdate}>
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <label className="form-label">Email</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            name="vchEmail"
                                                            value={formData.vchEmail || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Phone</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="vchMobTel"
                                                            value={formData.vchMobTel || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Department/Unit</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="vchDepartment"
                                                            value={formData.vchDepartment || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Designation</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="vchDesignation"
                                                            value={formData.vchDesignation || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-12">
                                                        <label className="form-label">Address</label>
                                                        <textarea
                                                            className="form-control"
                                                            name="vchPreAddress"
                                                            value={formData.vchPreAddress || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Company</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="vchCompanyName"
                                                            value={formData.vchCompanyName || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Gender</label>
                                                        <select
                                                            className="form-control"
                                                            name="vchGender"
                                                            value={formData.vchGender || ""}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Gender</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Date of Birth</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="dtmDob"
                                                            value={formData.dtmDob?.split("T")[0] || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="form-label">Date of Joining</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="dtmDoj"
                                                            value={formData.dtmDoj?.split("T")[0] || ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="col-12 d-flex justify-content-end gap-2 pt-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={() => setEditMode(false)}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button type="submit" className="btn btn-success">
                                                            Update
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeViewEditModal;
